<template>
    <div class="preUser expand">
        <div class="preUser-left">
            <div class="content-login"> 
                <b-link  to="/">
                    <img src="@/assets/img/logo-login.png" alt="" class="logo">
                </b-link>    
                <div v-if="!nextStep">
                    <b-form class="Login">
                    <div class="body">
                        <header>
                             <h6 class="sub-title"><span>Nueva Contraseña</span></h6>
                           
                           
                        </header>
                            <b-form-group label="New Password">
                                <b-icon class="eye" :icon="eyesPassword1 ? 'eye-slash':'eye'" aria-hidden="true" @click="eyesPassword1=!eyesPassword1"></b-icon>
                            <b-form-input
                                :type="eyesPassword1 ? 'password':'text'"
                                required
                                v-model="nwPassword"
                                @blur="$v.nwPassword.$touch()"
                              
                            ></b-form-input>
                            <div class="error-label">{{ validationMsg($v.nwPassword) }}</div>
                            </b-form-group>
                            <b-form-group label="Confirm Password">
                                <b-icon class="eye" :icon="eyesPassword2 ? 'eye-slash':'eye'" aria-hidden="true" @click="eyesPassword2=!eyesPassword2"></b-icon>
                            <b-form-input
                                required
                                v-model="confirmNwPassword"
                                @blur="$v.confirmNwPassword.$touch()"
                                v-on:keydown.enter.prevent="resetPassword"
                                 :type="eyesPassword2 ? 'password':'text'"
                            ></b-form-input>
                            <div class="error-label">{{ validationMsg($v.confirmNwPassword) }}</div>
                            </b-form-group>
                            <b-button class="w-100" variant="primary" :disabled="$v.nwPassword.$invalid || $v.confirmNwPassword.$invalid"  @click="resetPassword"  >
                                  <span style="color:#ffffff" v-if="!showSpinnerSave">Save password</span>
                                <b-spinner
                                    style="width: 1rem !important; height: 1rem !important"
                                    v-else
                                    variant="light"
                                    label="Spinning"
                                ></b-spinner>
                                </b-button>
                     

                    </div>
                        <p class="mb-0"><span><a href="/" class="link mt-3"><span>Back to login</span></a></span></p>
                    </b-form>
                </div>
                <div v-else style="width: 30vw;" class="">
                    <header>
                        <h6 class="sub-title"><span>Contraseña Creada</span></h6>
                    </header>
                    <p>Tu nueva contraseña ha sido creada sigue disfrutando de la experiencia en English Advanced.</p> 
                    <b-button  variant="primary" @click="$router.push({path : '/'});"  >
                        Entendido
                    </b-button>
                </div>
                
            </div>
        </div>
        <div class="preUser-right">
            <div class=third>
                <p>Propiedad de English Advance SAC, 2021. Todos los Derechos Reservados.</p>
            </div>
        </div>
        <b-toast
            id="toast-error-reset-password"
            variant="none"
            no-close-button
            toaster="b-toaster-top-center"
            >
            <img
                src="@/assets/img/ico-equis.png"
                style="margin-right: 10px; margin-top: -2px"
            />
            {{ message }}
		</b-toast>

          <b-toast
            id="toast-check-reset-password"
            variant="none"
            no-close-button
            toaster="b-toaster-top-center"
            >
            	<img
			src="@/assets/img/ico-check.png"
			style="margin-right: 10px; margin-top: -2px"
		/>
            {{ message }}
		</b-toast>
    </div>
    
</template>
<script>
import { PERFILES} from '@/assets/js/appConstants'; 
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import {
  required,
  sameAs,
  maxLength
} from "vuelidate/lib/validators";
import { validationMessage } from 'vuelidate-messages';
const formMessagesLogin = { 
    required: function (){
        return this.$t('validations.formMessagesLogin.required')
    },
    sameAsPassword:function (){
        return this.$t('validations.formRegisterMessages.sameAsPassword')
    },
    strongPassword:function (){
        return this.$t('validations.formRegisterMessages.strongPassword')
    },
    noWhitespaces:function (){
        return this.$t('validations.formRegisterMessages.noWhitespacesPassword')
    },
    maxLength:function ({ $params }){
        return `${this.$t('validations.formRegisterMessages.maxLength.1')} ${$params.maxLength.max } ${this.$t('validations.formRegisterMessages.maxLength.2')}`
    }

};


export default {
    data:function(){
        return{
            showSpinnerSave: false,
            key: null,
            nwPassword: null,
            confirmNwPassword: null,
            message: '',
            nextStep :false,
            personId : 0,
            eyesPassword1:true,
            eyesPassword2:true,
        }
    },
    created(){
    
        let dataEncoded = this.$route.params.key;
        let data = atob(dataEncoded);
        let dataArr = data.split("|");
        console.log(" dataArr: ", dataArr)
        let correoUsuario = dataArr[0];
        let perfil = parseInt(dataArr[1],10);
        this.validateRecoveryKey(correoUsuario,perfil)
    },
    computed: {  
    },
    validations: {
        nwPassword: {
        required,
        maxLength: maxLength(20),
        strongPassword(password) {
            return (
                   /[a-z]/.test(password) && // condición minúscula (a-z)
                        /[A-Z]/.test(password) && // condición mayúscula  (A-Z)
                        /[0-9]/.test(password) && // condición número (0-9)
                        /\W|_/.test(password) && // condición símbolo
                        password.length >= 6
            );
            },
        noWhitespaces(password) {
            return !/["/ +/"]/.test(password); // condición no espacios en blanco
        }
        },
        confirmNwPassword: {
            required,
            sameAsPassword: sameAs("nwPassword")
        }
    },
    methods: {
        validateRecoveryKey(email,type){
            let body = {
                email ,
                personsTypeId : type
            }
        

             baseInstanceAxios
				.post(`${this.apiURL}/resources/Persons/ValidatePasswordByUser`, body)
				.then(response => {
                    console.log("response : ",response)
                    if(response.data.entity){
                        this.personId = response.data.entity.id;
                        console.log("entro 1")
                    }else{
                         console.log("entro 2")
                        if(response.data){
                              console.log("entro 3")
                            this.message =response.data.message;
                            this.$bvToast.show("toast-error-reset-password");
                        }else{
                              console.log("entro 4")
                            this.message = this.$t('my-cours.mesage-system-error');
                            this.$bvToast.show("toast-error-reset-password");
                        }
                    }
				})
                .catch(error => {
                    this.message = this.$t('my-cours.mesage-system-error');
                    this.$bvToast.show("toast-error-reset-password");
          

                });
        },
        resetPassword(){
            this.showSpinnerSave  = true;
            let json = {
                Id: this.personId,
                Password:this.nwPassword
            }
             baseInstanceAxios
				.post(`${this.apiURL}/resources/Persons/SaveNewPassword`, json)
				.then(response => {
               
                  
                

                     if(response.data.value > 0){
                        this.message = this.$t('my-cours.saved-correctly');
                        this.$bvToast.show("toast-check-reset-password");
                        this.nextStep = true;
      
                    }else{
                        this.message = this.$t('my-cours.mesage-system-error');
                        this.$bvToast.show("toast-error-reset-password");
              
                    }
                     this.showSpinnerSave  = false;
				})
                .catch(error => {
                    this.message = this.$t('my-cours.mesage-system-error');
                    this.$bvToast.show("toast-error-reset-password");
                    this.showSpinnerSave = false;
                });
        },
        validationMsg: validationMessage(formMessagesLogin),
     
  
    },
};
</script>